import { KayakingIcon } from './KayakingIcon';

/**
 * author: Google
 * id 21C7383B-5839-4F3E-A4EC-81A9980F531B
 * name kayaking
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kayaking.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanKayakingIcon = KayakingIcon;
export default HumanKayakingIcon